import {Polygon} from "detect-collisions";
import {Vector} from "../i.js"; // ../vector.js
import {RES, sq} from "../i.js"; // ./dump.js
import {ConfigStructure, OptionalProperty, RequiredProperty} from "../i.js"; // ../validators.js
import {StraightLineAI} from "../i.js";
import {Thing, THING_TYPES, Z_INDICES} from "../i.js";

const SPEED = 1;  // flares / second

export class Wave extends Thing {
	static CONFIG_STRUCTURE = new ConfigStructure([
		// pos of this wave, a vector with values in flares
		new RequiredProperty("pos", v => (v instanceof Vector)),
		// rot of this wave, in radians
		new RequiredProperty("rot", v => Number.isFinite(v)),
		// Health of this wave
		new OptionalProperty("health", v => (Number.isFinite(v) && v >= 0))
	]);

	// Create a wave
	// config is an object with the properties provided by the spawn request
	// enrichment, plus the properties specified in CONFIG_STRUCTURE above.
	constructor(config) {
		Wave.CONFIG_STRUCTURE.test(config);

		let width = Math.sqrt(sq(0.3) + sq(0.15));

		config.texture = "images/desolation/wave.svg";
		config.zIndex = Z_INDICES.NPC_CHILD;
		let texture = RES["images/desolation/plate.svg"].texture;
		config.len = width * texture.height / texture.width;
		// Line class doesn't work because it messes with position
		config.hitbox = new Polygon({x: 0, y: 0}, [
			{x: 0, y: - width / 2},
			{x: 0, y: width / 2}
		]);
		config.type = THING_TYPES.SIZY_WEAPON;
		config.canDespawn = true;
		config.despawnSafetyWindow = 0;
		config.vel = new Vector(SPEED, 0)
			.rotateBy(config.rot);
		config.maxHealth = 8;
		super(config);
		this.ai = new StraightLineAI(this, {});
	}

	// Take damage from an attack
	// damage is a number.
	takeDamage(damage) {
		// Nothing to do here - a player can't damage a wave directly.
		// TODO: Remove on collision with a station.
	}
}
